/* 
 * Envío del formulario
 *
 * - Ejecucion en: $(document).ready()
 */

function formsGo(){


  $("#contact-submit").on('click', function(e){//formulario de contacto
    e.preventDefault();

    var okflag=true;
    $('input, textarea').filter('[required]:visible').each(function(i, requiredField){
      if($(requiredField).val()==''){
        if(okflag==true)$('#msg-all').fadeIn().delay(5000).fadeOut();
        okflag=false; 
        $(requiredField).addClass("contact-error");
      }
      else $(requiredField).removeClass("contact-error");
    });

    if(okflag==true)
      $('#msg').addClass("backGload").fadeIn().load('../contacto/contacto.php', {
        nombre: $('#contact-name').val(),
        email: $('#contact-email').val(),
        telefono: $('#contact-phone').val(),
        // ocupacion: $('#contact-occupation').val(),
        mensaje: $('#contact-message').val()
      }, function(){
        $('input, textarea').val("");
        $('#msg').removeClass("backGload");
      });

  });

}



/* 
 * Ejectuo las funciones de materialize
 *
 * - Ejecucion en: $(document).ready()
 */
function goMaterialize() {
  $(".button-collapse").sideNav();
  $('.home-slider').slider({full_width: true, height: 500});
  $('.news-slider').slider({height: 600});
  $('.parallax').parallax();
  $('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false, // Does not change width of dropdown to that of the activator
      hover: true, // Activate on hover
      gutter: 0, // Spacing from edge
      belowOrigin: true, // Displays dropdown below the button
      alignment: 'left' // Displays dropdown with edge aligned to the left of button
    }
  );
  $('.goto').scrollSpy();
}




/* 
 * Ejecuto funciones de slick slider
 *
 * - Ejecucion en: $(document).ready()
 */
 function goSliders() {

  $('.img-slider').slick({
    autoplay: true,
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ]
  });

}



/* 
 * Ejecuto funciones de fancybox
 *
 * - Ejecucion en: $(document).ready()
 */
function goFancy() {
  $('[data-fancybox]').fancybox({
    arrows : true,
    thumbs : {
        autoStart: true
    },
    mobile : {
        thumbs : {
            autoStart: true
        }
    }
  });
}



/* 
* Instanciamos las funciones :D
*
*/
$(document).ready (function () {
  "use strict";

  goMaterialize();
  formsGo();
  goSliders();
  goFancy();
  if ($("#map-canvas").length) contactMap();

  
});


// WEBPACK FOOTER //
// ./src/assets/js/app.js